import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertComponent } from './alert/alert.component';
import { FullscreenProgressSpinnerComponent } from './fullscreen-progress-spinner/fullscreen-progress-spinner.component';
import { RouterModule } from '@angular/router';

// Angular Material Design
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    MatMomentDateModule,
    MomentDateAdapter,
    MAT_MOMENT_DATE_FORMATS,
} from '@angular/material-moment-adapter';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from '@angular/material/core';

// Bootstrap
import { AlertModule } from 'ngx-bootstrap/alert';

@NgModule({
    declarations: [AlertComponent, FullscreenProgressSpinnerComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatToolbarModule,
        MatFormFieldModule,
        MaterialFileInputModule,
        MatButtonModule,
        MatInputModule,
        MatDatepickerModule,
        MatTabsModule,
        MatCheckboxModule,
        RouterModule,
        MatMomentDateModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatStepperModule,
        MatTableModule,
        MatPaginatorModule,
        MatChipsModule,
        MatSelectModule,
        MatIconModule,
        MatTooltipModule,
        MatCardModule,
        MatSnackBarModule,
        MatDividerModule,
        MatBadgeModule,
        MatMenuModule,
        AlertModule.forRoot(),
    ],
    exports: [
        ReactiveFormsModule,
        FormsModule,
        AlertComponent,
        FullscreenProgressSpinnerComponent,
        MatToolbarModule,
        MatFormFieldModule,
        MaterialFileInputModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatStepperModule,
        MatTableModule,
        MatPaginatorModule,
        MatChipsModule,
        MatSelectModule,
        MatIconModule,
        MatTooltipModule,
        RouterModule,
        MatCardModule,
        AlertModule,
        MatSnackBarModule,
        MatDividerModule,
        MatBadgeModule,
        MatMenuModule,
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
})
export class SharedModule {}
